import { Query } from 'types/queries';
import { useLoaderData } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

export function useQueryData<TData>(query: Query<TData>) {
  const initialData: TData = useLoaderData() as Awaited<TData>;
  const { data } = useQuery<TData>({
    ...query,
    initialData,
  });
  return data;
}
